const intro = (
  <p>
    <strong>Sekcja "Przypadki kliniczne"</strong> to zbiór rzeczywistych
    scenariuszy medycznych, które pomagają w nauce diagnozowania i podejmowania
    decyzji terapeutycznych. To narzędzie stworzone zarówno dla lekarzy, którzy
    chcą rozwijać swoje umiejętności kliniczne, jak i dla studentów medycyny
    przygotowujących się do egzaminów i praktyki zawodowej. Dzięki dostępnym
    analizom przypadków użytkownicy mogą uczyć się poprzez rozwiązywanie
    interaktywnych problemów medycznych, analizowanie historii choroby i
    interpretację wyników badań.
  </p>
);

const content = (
  <>
    <p>
      Wiedza teoretyczna to dopiero początek. Dopiero analiza rzeczywistych
      przypadków klinicznych pozwala lekarzom i studentom sprawdzić, jak wygląda
      diagnostyka i leczenie w praktyce.{" "}
      <strong>Sekcja "Przypadki kliniczne"</strong> została stworzona z myślą o
      tych, którzy chcą doskonalić swój warsztat i podejmować lepsze decyzje w
      codziennej pracy z pacjentami.
    </p>

    <p>
      Każdy przypadek to realistycznie opisany scenariusz, w którym użytkownik
      przechodzi przez cały proces – od pierwszych objawów zgłaszanych przez
      pacjenta, przez badania diagnostyczne, po wybór odpowiedniej metody
      leczenia. Przypadki obejmują różne specjalizacje medyczne, umożliwiając
      szerokie spojrzenie na problemy zdrowotne i ich rozwiązania.
    </p>

    <p>
      Dzięki tej bazie lekarze mogą weryfikować swoje podejście diagnostyczne, a
      studenci zdobywać praktyczną wiedzę niezbędną na egzaminach klinicznych.
      To także świetne wsparcie dla rezydentów, którzy na co dzień stykają się z
      nowymi wyzwaniami diagnostycznymi i muszą podejmować trafne decyzje
      terapeutyczne.
    </p>

    <h3>Jak działają przypadki kliniczne na Remedium?</h3>

    <p>
      Każdy przypadek prezentowany jest w przystępny sposób – zaczyna się od
      zgłoszenia pacjenta, historii choroby i objawów, po czym przechodzi do
      badań laboratoryjnych, obrazowych oraz możliwych diagnoz. Użytkownik
      analizuje wyniki i samodzielnie podejmuje decyzje dotyczące dalszego
      postępowania. Na końcu znajduje się podsumowanie, w którym omawiane są
      poprawne kroki diagnostyczne i terapeutyczne zgodne z najnowszymi
      wytycznymi medycznymi.
    </p>

    <p>
      Dzięki tej formule można nie tylko sprawdzić swoją wiedzę, ale też nauczyć
      się lepszego podejścia do pacjenta, unikania błędów diagnostycznych i
      stosowania najskuteczniejszych metod leczenia. To sposób na naukę, który
      angażuje i zmusza do myślenia – zupełnie jak w prawdziwej praktyce
      klinicznej.
    </p>

    <h3>Dlaczego warto korzystać z tej sekcji?</h3>

    <p>
      Lekarze i studenci medycyny często spotykają się z sytuacjami, w których
      nie ma jednej oczywistej odpowiedzi.{" "}
      <strong>Przypadki kliniczne na Remedium</strong> to przestrzeń, w której
      można przećwiczyć różne scenariusze, nauczyć się właściwej interpretacji
      objawów i wyników badań oraz zobaczyć, jak wygląda skuteczne leczenie w
      różnych dziedzinach medycyny.
    </p>

    <p>
      Regularne analizowanie przypadków pomaga w budowaniu umiejętności
      klinicznych, pozwala aktualizować wiedzę i przygotowuje do wyzwań w
      codziennej pracy. To narzędzie, które wspiera zarówno doświadczonych
      lekarzy, jak i tych, którzy dopiero zaczynają swoją drogę zawodową.
    </p>

    <h3>Podsumowanie</h3>

    <p>
      <strong>Sekcja "Przypadki kliniczne"</strong> to praktyczna baza wiedzy
      dla lekarzy i studentów, umożliwiająca naukę poprzez analizę rzeczywistych
      sytuacji klinicznych. To sposób na rozwijanie myślenia diagnostycznego,
      doskonalenie procesu podejmowania decyzji i skuteczniejsze leczenie
      pacjentów. Dzięki realistycznym scenariuszom użytkownicy mogą nie tylko
      poszerzać swoją wiedzę, ale przede wszystkim zdobywać praktyczne
      doświadczenie niezbędne w codziennej pracy.
    </p>
  </>
);

export const clinicalCaseDescription = { intro, content };
